import * as yup from 'yup';

export const NpsFeedbackSchema = yup.object().shape({
  evaluation: yup.number().min(1).max(10).required(),
});
